import {Injectable} from '@angular/core';
import {constants} from '@q9elements/ui-kit/common';

Injectable();
export class GdprStatusesService {
  public gdprStatuses = new Map<string, string>();

  constructor() {
    this.initGDPRStatuses();
  }

  private initGDPRStatuses(): void {
    constants.gdprOptions.gdprStatuses.forEach(status => {
      this.gdprStatuses.set(status.key, status.value);
    });
  }
}
